<template>
    <div class="container mescroll-touch">
        <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit" style="z-index: 9999;position: relative;">
            <div>
                <div class="topdh" @click="back"><img src="../../assets/images/bjback.png"
                        class="homeimg" />首页&nbsp;>&nbsp;任务检索
                </div>
                <img src="../../assets/images/bjtitle.png" class="img" />
                <!-- <img :src="imgurl" class="mainimg" alt="" /> -->
                <div class="main">
                    <div class="leftjt" v-if="searchdate.length != 0">&lt;</div>
                    <div class="rightjt" v-if="searchdate.length != 0">&gt;</div>
                    <div v-if="searchdate.length == 0"
                        style="text-align: center;color: rgb(169,169,169);padding: 0.2rem 0;">
                        暂无更多日期信息</div>
                    <div class="square_tab_scroll" ref="wrapper" v-if="searchdate.length != 0">
                        <div class="square_tab_wrapper">
                            <div class="item" v-for="(item, index) in searchdate" :key="index"
                                @click="listdate(item.DateStr, index)" :class="{ 'activeitem': activedate === index }">
                                <div class="mm">{{ item.MonthStr }}</div>
                                <div class="dd" :class="{ 'active': activedate === index }">{{ item.DayStr }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="search">
                    <div style="position: relative;">
                        <input type="text" class="nameinput" v-model="input" placeholder="请输入讲者主持人姓名查询" />
                        <img src="../../assets/images/ztsearchicon.png" class="searchicon" @click="namesearch" />
                    </div>
                </div>
                <div class="doclist">

                    <!-- <van-loading class="loadquan" v-if="loadop == 1" /> -->
                    <div class="docitem" v-for="(item, index) in docnamelist" :key="index"
                        @click="openlist(item.ExpertId)">
                        <div class="docleft">
                            <img :src="item.ExpertHead" class="docimg" />
                        </div>
                        <div class="docright">
                            <div class="docname">{{ item.ExpertName }}</div>
                            <div class="dochos">{{ item.ExpertHospital }}</div>
                        </div>
                    </div>
                    <!-- <div class="itemnone" v-if="docnamelist.length == 0">
                    <div style="text-align: center;color: rgb(169,169,169);">暂无更多信息</div>
                </div> -->
                </div>
                <div class="tankuangout" v-if="showlist == 1">
                    <div class="tankuangback" @click="showlist = 0"></div>
                    <div class="tankuangmain">
                        <div class="tktop">
                            <div class="tktopleft">
                                <div class="txout">
                                    <img :src="docinnerlist.ExpertHead" alt="" class="lefttouxiang" />
                                </div>
                            </div>
                            <div class="tktopright">
                                <div class="tkname">{{ docinnerlist.ExpertName }}</div>
                                <div class="tkhos">{{ docinnerlist.ExpertHospital }}</div>
                            </div>
                        </div>
                        <div class="tkinnerrow" v-for="(item, index) in docinnerlist.Schedule" :key="index"
                            @click="gomeeting(item.ActivityScheduleId)">
                            <div class="tkdayrow">
                                <span class="day"><img src="../../assets/images/tkday.png" class="tkimg" /><span>{{
                                    item.DateStr
                                        }}</span></span>
                            </div>
                            <div class="tkxueshurow" v-if="item.Mission">学术任务：{{ item.Mission }}</div>
                            <div class="tkxueshurow" v-else>学术任务：暂无</div>
                            <div class="tkkhrow">【{{ item.Theme }}】</div>
                            <div class="tktitlerow">{{ item.Title }}</div>
                            <div class="tktime"><img src="../../assets/images/tktime.png" class="tkimg" /><span>{{
                                item.StartTimeStr }} - {{ item.EndTimeStr }}</span></div>
                            <div class="tkpos"><img src="../../assets/images/tkpos.png" class="tkimg" /><span>{{
                                item.Address
                                    }}</span></div>
                            <div class="tkopen">查看详情<span class="s1">></span><span class="s2">></span><span
                                    class="s3">></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mescroll-vue>
        <img src="../../assets/images/bjfooter.png" class="footerimg" />
    </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from "mescroll.js/mescroll.vue";
// import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
    name: 'bjjiansuo',
    data() {
        return {
            imgurl: '',
            PageIndex: 0,
            PageSize: 6,
            mescroll: null, // mescroll实例对象
            mescrollDown: {
                use: false,
                isLock: false,
            },
            mescrollUp: {
                // 上拉加载的配置.
                auto: false,
                isBounce: false,
                callback: this.upCallback, // 上拉回调
                page: {
                    num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
                    size: 10, //每页数据条数,默认10
                },
                noMoreSize: 0,
                toTop: {
                    warpId: "toTop",
                    src: "./static/image/top_comm_icon@2x.png", // 回到顶部按钮的图片路径,支持网络图
                },
            },
            searchdate: '',
            activedate: 0,
            input: '',
            upday: '',
            docnamelist: [],
            docinnerlist: [],
            showlist: 0,
            loadop: 1
        }
    },
    mixins: [mixin],
    components: {
        MescrollVue
    },
    created() {
        this.getdate()
        this.initbjShare();
        this.getinfo()
        document.title = "第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会";
    },
    updated() {
        console.log('Component updated', this.docnamelist);
    },
    methods: {
        getinfo() {
            let that = this;
            this.$axios.post('/api/api/web/activity/GetBJConfig?code=HWXX').then(res => {
                if (res.RetCode == "10000") {
                    // console.log(res.Data.Url)
                    that.imgurl = res.Data.Url
                }
            });
        },
        back() {
            this.$router.replace({ name: 'BJZL' })
        },
        upCallback(page) {
            let that = this;
            this.getList(page.num, page.size, that.upday, that.input);
        },
        mescrollInit(mescroll) {
            this.mescroll = mescroll; // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
        },
        initBScroll() {
            this.$nextTick(() => {
                this.scroll = new BScroll(this.$refs['wrapper'], {
                    startX: 0,
                    click: true,
                    scrollX: true,
                    scrollY: false,
                    eventPassthrough: 'vertical'
                })
            })
        },
        getList(page, size, date, name) {
            let that = this;
            that.$axios.post('/api/api/web/activity/GetScheduleExpert', {
                ActivityCode: "BJZLNH9",
                Date: date,
                PageIndex: page,
                PageSize: size,
                Name: name,
            }).then(res => {
                // that.docnamelist = res.Data
                // console.log(that.docnamelist)
                if (page === 1) that.docnamelist = [];
                that.docnamelist = that.docnamelist.concat(res.Data.List);
                this.$nextTick(() => {
                    this.mescroll.endSuccess(res.Data.List.length);
                });
            })
        },
        getdate() {
            let that = this;
            this.$axios.post('/api/api/web/activity/GetScheduleDateNew', {
                ActivityCode: "BJZLNH9",
            }).then(res => {
                that.searchdate = res.Data
                that.upday = res.Data[0].DateStr;
                // that.docnamelist = [];
                // that.$axios.post(' /api/api/web/activity/GetScheduleExpert', {
                //     ActivityCode: "BJZLNH9",
                //     Date: res.Data[0].DateStr
                // }).then(res => {
                //     that.docnamelist = res.Data
                // })
                that.mescroll && that.mescroll.resetUpScroll();
                // that.getList(that.mescrollUp.page.num, that.mescrollUp.page.size, that.upday, that.input)
                // console.log(that.docnamelist)
            })
        },
        listdate(e, i) {
            let that = this;
            // console.log(e)
            this.activedate = i
            that.upday = e;
            // console.log(i)
            that.docnamelist = [];
            that.mescroll.resetUpScroll()
            // that.getList(that.mescrollUp.page.num, that.mescrollUp.page.size, that.upday, that.input)
        },
        namesearch() {
            let that = this;
            // // console.log(i)
            // this.$axios.post(' /api/api/web/activity/GetScheduleExpert', {
            //     ActivityCode: "BJZLNH9",
            //     Date: that.upday,
            //     Name: that.input,
            // }).then(res => {
            //     that.docnamelist = res.Data
            //     // that.searchdate = res.Data
            //     // console.log(res.Data)
            // })
            that.docnamelist = [];
            that.mescroll.resetUpScroll()
            // that.getList(that.mescrollUp.page.num, that.mescrollUp.page.size, that.upday, that.input)    
        },
        openlist(i) {
            let that = this;
            that.docinnerlist = [];
            // console.log(i)
            this.$axios.get('/api/api/web/activity/GetScheduleByExpert?expertId=' + i + '&ActivityId=5').then(res => {
                if (res.RetCode == "10000") {
                    // console.log(res.Data.Url)
                    that.docinnerlist = res.Data;
                    console.log(that.docinnerlist)
                    that.showlist = 1
                    // that.imgurl = res.Data.Url
                }
            });
        },
        gomeeting(id) {
            this.$router.push({
                path: 'bjmeeting',
                query: {
                    Id: id,
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
body {
    -webkit-overflow-scrolling: unset
}

.container {
    height: 100%;
    width: 100%;
    position: relative;
    -webkit-overflow-scrolling: unset; // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    // margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 90%;
    margin: 0.5rem auto;
}

.footerimg {
    display: block;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background-image: linear-gradient(to right, #01B671, #2D5EAA);
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.main {
    background-image: linear-gradient(to right, #E8F6F7, #E8EFF7);
    padding: 0 0.7rem;
    position: relative;
    margin-bottom: 0.2rem;
}

.square_tab_scroll {
    display: flex;
    flex-wrap: nowrap;
    overflow: auto;
    margin-bottom: 8px;
    margin-top: -6px;
    padding: 6px 0;

    .square_tab_wrapper {
        display: flex;
        flex-direction: row;
        white-space: nowrap;
    }
}

/* 隐藏水平滚动条 */
.square_tab_scroll::-webkit-scrollbar {
    display: none;
}

.item {
    display: flex;
    flex-direction: column;
    text-align: center;
    background: #fff;
    margin-right: 0.2rem;
    font-size: .33rem;
    border-radius: 3px;
    border: 1px solid #90B4B4;
}

.mm {
    padding: 0 0.4rem;
    color: #90B4B4;
}

.dd {
    padding: 0 0.4rem;
    background: #90B4B4;
    color: #fff;
}

.active {
    background: #286BB1;
    color: #fff
}

.activeitem {
    border: 1px solid #286BB1;
}

.leftjt {
    font-family: cursive;
    font-weight: bold;
    color: #9b9b9b;
    position: absolute;
    left: .25rem;
    top: 50%;
    transform: translateY(-50%);
}

.rightjt {
    font-family: cursive;
    font-weight: bold;
    color: #9b9b9b;
    position: absolute;
    right: .25rem;
    top: 50%;
    transform: translateY(-50%);
}

.nameinput {
    background-image: linear-gradient(to right, #E8F6F7, #E8EFF7);
    display: block;
    margin: auto;
    width: 85%;
    border-radius: 50rem;
    border: 0;
    font-size: .4rem;
    padding: 0.2rem 0.4rem;
    color: #90B4B4;
    padding-right: 1rem;
    box-sizing: border-box;
}

.searchicon {
    position: absolute;
    right: 1rem;
    top: 50%;
    width: 6%;
    transform: translateY(-50%);
}

.doclist {
    margin-top: 0.3rem;
    box-sizing: border-box;
    padding: 0 1rem;
}

.docitem {
    display: flex;
    flex-direction: row;
    background-image: linear-gradient(to bottom, #FEFEFE, #FEFCFD);
    margin-bottom: 0.3rem;
    box-shadow: 0.02rem 0.02rem 0.1rem 0 rgba(0, 0, 0, 0.2);
    border-radius: 0.4rem;
    box-sizing: border-box;
    padding: 0.2rem 0.2rem;
    z-index: 20;
    position: relative;
}

.docleft {
    width: 1.3rem;
    height: 1.3rem;
    position: relative;
    overflow: hidden;
    border-radius: 50rem;
    margin-right: 0.3rem;
}

.docright {
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.docimg {
    width: 100%;
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
}

.dochos {
    font-size: .32rem;
}

.tankuangout {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999999;
}

.tankuangback {
    width: 100%;
    height: 100%;
    z-index: 50;
    position: relative;
    background: rgba(0, 0, 0, 0.5);
}

.tankuangmain {
    width: 90%;
    position: absolute;
    background: #fff;
}

.tankuangmain {
    width: 90%;
    position: absolute;
    background: #fff;
    left: 50%;
    transform: translateX(-50%);
    top: 1rem;
    z-index: 55;
    border-radius: 0.5rem;
    overflow-y: scroll;
    height: 90%;
}

.tktop {
    display: flex;
    flex-direction: row;
    width: 100%;
    background-image: linear-gradient(to bottom, #1FA1BB, #277EB3);
    padding: 0.4rem 0;
}

.tktopleft {
    width: 25%;
}

.tktopright {
    width: 75%;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.lefttouxiang {
    width: 100%;
    display: block;
    margin: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.txout {
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50rem;
    overflow: hidden;
    position: relative;
    margin: auto;
    background: #fff;
}

.tkname {
    font-size: .55rem;
    font-weight: bold;
}

.tkinnerrow {
    padding: 0.4rem 0;
    width: 85%;
    border-bottom: 1px solid #2781B5;
    margin: auto;
    color: #2781B5
}

.day {
    background: #2781B5;
    color: #fff;
    padding: 0 0.1rem;
}

.tkdayrow {
    margin-bottom: 0.2rem;
}

.tkxueshurow {
    margin-bottom: 0.1rem;
}

.tkkhrow {
    margin-bottom: 0.1rem;
}

.tktitlerow {
    margin-bottom: 0.3rem;
}

.tktime {
    margin-bottom: 0.3rem;
}

.tkpos {
    margin-bottom: 0.3rem;
}

.tkopen {
    text-align: right;
    color: #8f8f8f;
}

.s1 {
    font-family: cursive;
    font-weight: bold;
    margin-left: 0.1rem;
    vertical-align: middle;
}

.s2 {
    font-family: cursive;
    font-weight: bold;
    vertical-align: middle;
    color: #c2c2c2;
}

.s3 {
    font-family: cursive;
    font-weight: bold;
    vertical-align: middle;
    color: #dddcdc;
}

.tkimg {
    width: .34rem;
    transform: translateY(0.025rem);
    margin-right: 0.1rem;
}

.loadquan {
    text-align: center;
    margin-top: 1rem;
}

::v-deep .upwarp-nodata {
    margin-bottom: 1.5rem;
}
</style>